















































































import { Component, Vue } from "vue-property-decorator";
import {
  NavBar,
  Calendar,
  Dialog,
  Popup,
  DatetimePicker,
  Progress
} from "vant";
import { formatDate } from "@/utils/date";
import { setStatementDetailInfo } from "@/utils/hybirdMethods";
import { getBrowser } from "@/utils/browser";
const browser = getBrowser();
const PDFJS = require("pdfjs-dist");
PDFJS.GlobalWorkerOptions.workerSrc = "pdfjs-dist/build/pdf.worker.js";

@Component({
  components: {
    [NavBar.name]: NavBar,
    [Calendar.name]: Calendar,
    [Dialog.Component.name]: Dialog.Component,
    [Calendar.name]: Calendar,
    [Popup.name]: Popup,
    [DatetimePicker.name]: DatetimePicker,
    [Progress.name]: Progress
  }
})
export default class Detail extends Vue {
  isApp = browser.isApp;
  isLoading = true;
  hasStatement = false;
  pages = 1;
  pdf_url: any = ""; // pdf oss地址
  pdfDoc: any = null; //pdf.js解析后的pdf对象
  statementDate = "";
  account_type;
  statement_type;
  showCalendar = false;
  minDate = new Date("2000-01-01");
  defaultDate = new Date();
  scale = 1;
  showDatetimePicker = false;
  pdfArrayBuffer;
  fileName = "";
  showProgress = false;
  loadingPDFPercentage = 0;
  bgColor = this.$store.getters["common/bgColor"];

  get statementTypeText() {
    if (this.statement_type == 1) {
      return this.$t("statement.day_statement");
    } else if (this.statement_type == 2) {
      return this.$t("statement.month_statement");
    } else {
      return "";
    }
  }

  get accountTypeText() {
    if (this.account_type == 1) {
      return this.$t("statement.statement_type[0]");
    } else if (this.account_type == 3) {
      return this.$t("statement.statement_type[1]");
    } else {
      return "";
    }
  }

  get headerTitle() {
    return `${this.accountTypeText}${this.statementTypeText} ${this.statementDate}`;
  }

  created() {
    const { statement_type, account_type } = this.$route.query;
    this.statement_type = statement_type;
    this.account_type = account_type;
    if (this.statement_type == 1) {
      this.statementDate = formatDate(new Date(), "yyyy/MM/dd");
    } else {
      this.statementDate = formatDate(new Date(), "yyyy/MM");
    }
    (this as any).$JsBridge.registerHandler("setDateTimePickerShow", () => {
      this.handleSelectStatementDate();
    });

    setStatementDetailInfo({
      headerTitle: this.headerTitle,
      downloadUrl: this.pdf_url
    });
    this.handleGetStatementDetail();
    // this._loadFile(
    //   "https://futures-oss-test.1quant.com.cn/statement/6-2020-04-26-14-00-10-78016976.pdf?OSSAccessKeyId=LTAIr06eQFVfgKX9&Expires=1588068922&Signature=BWzJfwWtfB%2FsmlcoFkzWdlQBmSc%3D"
    // );
    // const url =
    //   "https://futuresapp-server.1quant.com.cn/api/contract/have_contract?pdf_url=https://futures-oss-test.1quant.com.cn/contract_pdf/1-2020-04-28-10-31-43-69911401.pdf%3FOSSAccessKeyId%3DLTAIr06eQFVfgKX9%26Expires%3D1588051903%26Signature%3DQiC2MLRIHTBl1PdET0BsTDCaLb8%253D";
    // this._loadFile(url);
  }

  formatter(type, val) {
    if (type === "year") {
      return `${val}年`;
    } else if (type === "month") {
      return `${val}月`;
    }
    return val;
  }

  handleSelectStatementDate() {
    if (this.statement_type == 1) {
      this.showCalendar = true;
    } else {
      this.showDatetimePicker = true;
    }
  }

  handleGetStatementDetail() {
    this.isLoading = true;
    const params = {
      statement_time: this.statementDate.replace(/(\/)/g, "-"),
      statement_type: this.statement_type,
      account_type: this.account_type
    };
    (this as any).$apis
      .getStatementDetail(params)
      .then(res => {
        this.isLoading = false;
        const { pdf_url } = res;
        this.pdf_url = pdf_url;
        if (pdf_url) {
          this.hasStatement = true;
          this.handlePreviewStatementPdf();
        } else {
          this.hasStatement = false;
        }
        setStatementDetailInfo({
          headerTitle: this.headerTitle,
          downloadUrl: this.pdf_url
        });
      })
      .catch(e => {
        this.isLoading = false;
        
      });
  }

  handlePreviewStatementPdf() {
    (this as any).$apis
      .previewStatementPdf({
        pdf_url: this.pdf_url
      })
      .then(res => {
        this.fileName = res.headers["content-disposition"]
          .split(";")[1]
          .split("filename=")[1]
          .replace(/"/g, "");
        this.pdfArrayBuffer = res.data;
        this._loadFile(res.data);
      })
      .catch(e => {
        
      });
    // const url = `${process.env.VUE_APP_STATEMENT_URL}/api/statement/pdf?pdf_url=${pdf_url}`;
    // 
  }

  downloadPDF() {
    if (!this.pdf_url) {
      return this.$dialog
        .alert({
          message: "暂无结算单"
        })
        .then(() => {
          // on close
        });
    }
    this.fileDownload(this.pdfArrayBuffer, this.fileName);
    // (this as any).$apis
    //   .previewStatementPdf({
    //     pdf_url: this.pdf_url
    //   })
    //   .then(res => {
    //     const fileName = res.headers["content-disposition"]
    //       .split(";")[1]
    //       .split("filename=")[1]
    //       .replace(/"/g, "");
    //     this.fileDownload(res.data, fileName);
    //   })
    //   .catch(e => {
    //     
    //   });
  }

  fileDownload(data, fileName) {
    const blob = new Blob([data], {
      //type类型后端返回来的数据中会有，根据自己实际进行修改
      type: "application/pdf;charset-UTF-8"
    });
    const filename = fileName || "结算表.pdf";

    if (typeof window.navigator.msSaveBlob !== "undefined") {
      
      window.navigator.msSaveBlob(blob, filename);
    } else {
      const blobURL = window.URL.createObjectURL(blob);
      
      // 创建隐藏<a>标签进行下载
      const tempLink = document.createElement("a");
      tempLink.style.display = "none";
      tempLink.href = blobURL;
      tempLink.setAttribute("download", filename);
      if (typeof tempLink.download === "undefined") {
        tempLink.setAttribute("target", "_blank");
      }
      document.body.appendChild(tempLink);
      tempLink.click();
      document.body.removeChild(tempLink);
      window.URL.revokeObjectURL(blobURL);
    }
  }

  handleConfirmStatementDate(date) {
    this.statementDate = formatDate(date, "yyyy/MM/dd");
    this.showCalendar = false;
    this.handleGetStatementDetail();
  }

  handleConfirmStatementMonth(date) {
    this.statementDate = formatDate(date, "yyyy/MM");
    this.showDatetimePicker = false;
    this.handleGetStatementDetail();
  }

  handleClickLeft() {
    this.$router.go(-1);
  }

  handlePinch() {
    // 
    // this.scale = 2;
    // // (this.$refs.canvas as any).style.width = this.scale * 100 + "%";
    // this._renderPage(1);
    // 
    // (this.$refs.viewPdf as any).style.transform = "scale(3)";
  }

  _renderPage(num) {
    this.pdfDoc.getPage(num).then(page => {
      const canvas: any = document.getElementById("the-canvas" + num);
      const ctx = canvas.getContext("2d");
      // const scale = 1;
      // const viewport = page.getViewport(3);
      // canvas.width = viewport.width;
      // canvas.height = viewport.height;
      // canvas.style.width = "100%";
      // canvas.style.height = "100%";
      const dpr = window.devicePixelRatio || 1;
      const bsr =
        ctx.webkitBackingStorePixelRatio ||
        ctx.mozBackingStorePixelRatio ||
        ctx.msBackingStorePixelRatio ||
        ctx.oBackingStorePixelRatio ||
        ctx.backingStorePixelRatio ||
        1;
      const ratio = dpr / bsr;
      const viewport = page.getViewport(
        screen.availWidth / page.getViewport(1).width
      );
      canvas.width = viewport.width * ratio;
      canvas.height = viewport.height * ratio;
      canvas.style.width = "100%";
      canvas.style.height = "100%";
      // canvas.style.width = viewport.width + "px";
      // canvas.style.height = viewport.height + "px";
      ctx.setTransform(ratio, 0, 0, ratio, 0, 0);

      const renderContext = {
        canvasContext: ctx,
        viewport: viewport
      };
      page.render(renderContext);
      if (this.pages > num) {
        this._renderPage(num + 1);
      }
    });
  }

  _loadFile(url) {
    const loadingTask = PDFJS.getDocument(url);
    this.showProgress = true;
    loadingTask.onProgress = e => {
      
      const { loaded, total } = e;
      this.loadingPDFPercentage = (loaded / total) * 100;
      if (this.loadingPDFPercentage == 100) {
        this.showProgress = false;
      }
    };

    loadingTask
      .then(pdf => {
        this.pdfDoc = pdf;
        
        this.pages = this.pdfDoc.numPages;
        this.$nextTick(() => {
          this._renderPage(1);
        });
      })
      .catch(e => {
        
      });
  }
}
